import React from "react"

const SolutionLevelReportExportContext = React.createContext(null)

export default SolutionLevelReportExportContext
